import { Icon } from '@fluentui/react';
import { getFileCategory, getFileExtension } from '@/config';

interface FileIconProps {
  name: string;
  isFolder: boolean;
  size?: number;
}

const iconMap: Record<string, string> = {
  folder: 'FolderHorizontal',
  image: 'FileImage',
  video: 'Video',
  audio: 'MusicInCollection',
  document: 'Document',
  text: 'TextDocument',
  code: 'FileCode',
  email: 'Mail',
  archive: 'ZipFolder',
  pdf: 'PDF',
  excel: 'ExcelDocument',
  word: 'WordDocument',
  powerpoint: 'PowerPointDocument',
  unknown: 'Page',
};

export function FileIcon({ name, isFolder, size = 16 }: FileIconProps) {
  let iconName = 'Page';

  if (isFolder) {
    iconName = 'FolderHorizontal';
  } else {
    const category = getFileCategory(name);
    const ext = getFileExtension(name);

    if (ext === 'pdf') {
      iconName = 'PDF';
    } else if (['xls', 'xlsx'].includes(ext)) {
      iconName = 'ExcelDocument';
    } else if (['doc', 'docx'].includes(ext)) {
      iconName = 'WordDocument';
    } else if (['ppt', 'pptx'].includes(ext)) {
      iconName = 'PowerPointDocument';
    } else {
      iconName = iconMap[category] || 'Page';
    }
  }

  return (
    <Icon
      iconName={iconName}
      styles={{
        root: {
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size,
          height: size,
          fontSize: size,
          color: 'var(--accent-primary)',
        },
      }}
    />
  );
}
